var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.usrCanCreateGroup)?_c('v-btn',{attrs:{"small":_vm.small,"data-testid":"newGroup","block":_vm.block},on:{"click":_vm.click}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._v(" "+_vm._s(_vm.$t("newGroup"))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }